import React, { useEffect, useState } from "react";
import { Container_List } from "../components/Container_List";
import request from "../../Helpers/API";
import Swal from "sweetalert2";

import { DashboardCobranzaScreen2 } from "./DashboardCobranza/DashboardCobranzaScreen2";

export const ListadoReportesCobranza = () => {
  const [cards, setCards] = useState([]);
  const [permiso, setPermiso] = useState();

  useEffect(() => {
    request
      .get(`PermisoCobranza/GetPermiso`)
      .then((result) => {
        setPermiso(result.permiso);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    localStorage.removeItem('state');
    localStorage.removeItem('ruta');
    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=5`)
      .then((result) => {
        const cards_array = result.map((item) => ({
          titulo: item.titulo,
          ruta: item.ruta,
        }));
        setCards(cards_array);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);

  return (
      permiso === "Dashboard" ? (
        <DashboardCobranzaScreen2/>
      ) : (
        <Container_List titulo={"LISTADO DE REPORTES DE COBRANZA"} cards={cards} />
      )
  );
};
